import { Announcement, IAnnouncement } from './Announcement';
import { CDRTEvent, ICDRTEvent } from './CDRTEvent';
import { IPromo, Promo } from './Promo';
import { ITrip, Trip } from './Trip';

export interface INotification {
  id: number;
  title: string;
  message: string;
  event: ICDRTEvent;
  announcement: IAnnouncement;
  trip: ITrip;
  promo: IPromo;
  createdAt: Date;
}

export const Notification = (data: { id: number; attributes: any }): any => {
  return {
    id: data.id,
    title: data.attributes.title,
    message: data.attributes.message,
    event:
      data.attributes.event?.data && CDRTEvent(data.attributes.event?.data),
    promo: data.attributes.promo?.data && Promo(data.attributes.promo?.data),
    trip: data.attributes.trip?.data && Trip(data.attributes.trip?.data),
    announcement:
      data.attributes.announcement?.data &&
      Announcement(data.attributes.announcement?.data),
    createdAt: data.attributes.createdAt
      ? new Date(data.attributes.createdAt)
      : null,
  };
};
